import { render } from "./SubscribeDiffrent.vue?vue&type=template&id=4f0c98cd&scoped=true"
import script from "./SubscribeDiffrent.vue?vue&type=script&lang=js"
export * from "./SubscribeDiffrent.vue?vue&type=script&lang=js"

import "./SubscribeDiffrent.vue?vue&type=style&index=0&id=4f0c98cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0c98cd"]])

export default __exports__